import { IsUUID, IsBoolean } from "class-validator";

export default class TestAnswer {
  @IsUUID("4")
  public readonly id!: string;

  @IsBoolean()
  public is_correct: boolean = false;
}
